import { PayloadAction } from '@reduxjs/toolkit';
import { Environment, ICopyTemplateState } from './copyTemplate.slice';
import { copyTemplate, ICopyTemplateResponse } from './copyTemplate.thunks';

export const reducers = {
  [copyTemplate?.pending.type]: (state: ICopyTemplateState): void => {
    state.loading = true;
    state.projectId = null;
    state.env = null;
  },
  [copyTemplate?.rejected.type]: (state: ICopyTemplateState): void => {
    state.loading = false;
  },
  [copyTemplate?.fulfilled.type]: (state: ICopyTemplateState, action: PayloadAction<ICopyTemplateResponse>): void => {
    state.loading = false;
    state.projectId = action.payload.projectId;
    state.env = action.payload.env as Environment;
  }
};
